/** Situações da entidade Usuario */
export interface UsuarioSituacao {
    id: number,
    nome: string;
}

export const usuarioAtivo: UsuarioSituacao = {id: 1, nome: 'Ativo'};
export const usuarioInativo: UsuarioSituacao = {id: 2, nome: 'Inativo'};

export const usuarioSituacoes: UsuarioSituacao[] = [
    usuarioAtivo,
    usuarioInativo
];
